import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteEventChainLink } from '../index';
export const useDeleteEventChainLink = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(deleteEventChainLink, {
        onSuccess: () => {
            queryClient.invalidateQueries('EventChainLinks');
            setAction({
                type: 'success',
                message: 'Removing the event chain link was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
